// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"424b7550","198":"d3e4821d","241":"f261bab3","307":"cfc0da7f","452":"1d219117","875":"7a72cede","898":"ad09bba9"}[chunkId] + ".chunk.js";
};